<div class="appointment-locations-container public-profile-card" [ngClass]="{'show-locations':showLocations}" *ngIf="showCard">
    <div class="card-container">

        <mat-card *ngIf="finishLoading">
        
            <!-- Header -->
            <mat-card-header>
                <mat-icon fontSet="phr-iconset" class="phr-iconset-hospital"></mat-icon>
                <span class="header-title">{{ 'publicProfiles.appointmentLocations.title' | translate:locale.language }}</span>                        
                <!--<button mat-icon-button class="collapse-button" (click)="toggleLocations()">
                    <mat-icon fontSet="phr-iconset" class="phr-iconset-arrow-down-big"></mat-icon>
                </button>-->
            </mat-card-header>
    
            <div class="header-separator"></div>
    
            <!-- Content -->
            <mat-card-content *ngIf="showLocations">
                <div class="location-container" *ngFor="let location of publicProfile.localidades; index as i; trackBy: locationTrackBy">
                    <app-appointment-location [location]="location" [publicProfile]="publicProfile" [selectedLocationId]="selectedLocationId"></app-appointment-location>
                </div>
            </mat-card-content>
    
        </mat-card>
        
        <mat-card class="skeleton-card" *ngIf="!finishLoading">               
            <mat-card-header>
                <span class="header-title">
                    <ngx-skeleton-loader [theme]="{ 'width': '190px', 'height': '17px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>         
                </span>
            </mat-card-header>
            
            <div class="header-separator"></div>
            
            <mat-card-content>                
                <div>
                    <ngx-skeleton-loader [theme]="{ 'width': '18%', 'height': '13px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px', 'margin-bottom': '29px'}"></ngx-skeleton-loader>
                </div>
                <div>
                    <ngx-skeleton-loader [theme]="{ 'width': '25%', 'height': '13px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px', 'margin-bottom': '29px'}"></ngx-skeleton-loader>
                </div>
                <div>
                    <ngx-skeleton-loader [theme]="{ 'width': '19%', 'height': '13px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px', 'margin-bottom': '29px'}"></ngx-skeleton-loader>
                </div>
                <div>
                    <ngx-skeleton-loader [theme]="{ 'width': '18%', 'height': '13px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px', 'margin-bottom': '29px'}"></ngx-skeleton-loader>
                </div>
                <div>
                    <ngx-skeleton-loader [theme]="{ 'width': '28%', 'height': '13px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px'}"></ngx-skeleton-loader>
                </div>                   
            </mat-card-content>
        </mat-card>

    </div>
</div>